import React, { useState, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Box } from '@mui/material';
import GenericTable from './GenericTable';
import { entrepriseCandidatureStatus } from './constants/options';

const InfosComplementaires = ({ candidatures = [], viewerType }) => {
  const navigate = useNavigate();
  const [displayMode, setDisplayMode] = useState('table');

  const columns = useMemo(() => ([
    { key: 'reference',  label: 'Référence' },
    ...(viewerType === 'entreprise' ? [{ key: 'recruteur', label: 'Recruteur' }] : []),
    { key: 'tarif',      label: 'Tarif' },
    { key: 'statut',     label: 'Statut' },
    { key: 'dateEnvoi',  label: 'Date de candidature' },
  ]), [viewerType]);

  const filtered = useMemo(() => (
    viewerType === 'entreprise'
      ? candidatures.filter(c => c.statut?.toLowerCase() !== 'brouillon')
      : candidatures
  ), [candidatures, viewerType]);

  const formatData = (list) => list.map((c) => {
    const rawStatus = c.statut || 'Inconnu';
    const overrideLabel =
      rawStatus === 'A traiter' || rawStatus === 'Candidature envoyée'
        ? 'Candidature à traiter'
        : null;

    const matchedStatus = entrepriseCandidatureStatus.find((s) => s.value === rawStatus);

    const statutNode = (
      <span className="status-cell" style={matchedStatus?.style}>
        {overrideLabel || matchedStatus?.label || rawStatus}
      </span>
    );

    const devise = c.devise || '';
    const montant = c.tarif ? String(c.tarif).replace(/"/g, '') : '—';

    return {
      _id: c._id,
      missionId: c.missionId?._id || c.missionId,
      candidatId: c.candidatId?._id || c.candidatId,
      isBrouillon: c.statut?.toLowerCase() === 'brouillon',

      reference: c.candidatId?.reference || 'N/A',
      recruteur:
        viewerType === 'entreprise'
          ? `${c.recruteur?.firstName || ''} ${c.recruteur?.lastName || ''}`.trim() || 'N/A'
          : undefined, 
      tarif: `${montant} ${devise}`.trim(),
      statut: statutNode,
      dateEnvoi: c.dateEnvoi
        ? new Date(c.dateEnvoi).toLocaleDateString('fr-FR')
        : 'N/A',
    };
  });

  const tableData = useMemo(() => formatData(filtered), [filtered]);

  const renderActions = (row) => {
    const basePath = viewerType === 'entreprise' ? 'Entreprise' : 'Recruteur';

    const handleClick = () => {
      if (row.isBrouillon) {
        window.open(`/recruteur/travailler-mission/${row.missionId}?t=${row.candidatId}`, '_blank');
      } else {
        navigate(`/${basePath}/DetailsCandidature/${row._id}`);
      }
    };

    return (
      <button
        className={`btn-small ${row.isBrouillon ? 'resume-button' : 'details-button'}`}
        onClick={handleClick}
      >
        {row.isBrouillon ? 'Reprendre' : 'Détails'}
      </button>
    );
  };

  return (
    <Box className="mission-container">
      <Typography variant="h6" mb={2} className="section-title">
        Suivi des candidatures
      </Typography>

      {tableData.length === 0 ? (
        <Typography variant="body2" fontStyle="italic" className="no-candidature-text">
          Aucune candidature envoyée pour cette mission.
        </Typography>
      ) : (
        <GenericTable
          columns={columns}
          data={tableData}                
          renderActions={renderActions}
          displayMode={displayMode}
          setDisplayMode={setDisplayMode}
          showCheckboxes={false}
        />
      )}
    </Box>
  );
};

export default InfosComplementaires;
